import React from 'react';
import { View, ImageBackground } from 'react-native-web';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TransitionSpinner from './TransitionSpinner';

import './Spinner.module.scss';

const LOADING_SPINNER = require('../../../images/ajax-loader.gif');
const LOADING_SPINNER_DARK = require('../../../images/ajax-loader-dark.gif');

export const APPEARANCE_OPTIONS = [
  'navigating',
  'loading',
  'loading-dark',
  'inline',
  'inline-dark',
];
export const DEFAULT_APPEARANCE = 'loading';

/**
 * Shows a spinner over top of the parent element.
 *
 * This uses the rebranded spinner image.
 */
export default function Spinner({
  appearance, show, testID,
}) {
  const imageSource = appearance.endsWith('-dark')
    ? LOADING_SPINNER_DARK
    : LOADING_SPINNER;

  // TODO: Rebranded full-screen spinner
  return (appearance === 'navigating' || !APPEARANCE_OPTIONS.includes(appearance)) ? (
    <TransitionSpinner show={show} testID={testID} />
  ) : (
    <View styleName={classNames('spinner', appearance, { show })} testID={testID}>
      <ImageBackground style={{ width: 75, height: 75 }} source={imageSource} />
    </View>
  );
}

Spinner.propTypes = {
  /** The appearance of the spinner and its mask
   * navigating - A full-page transition, which darkens and blocks the entire page
   * loading - Indicates data is loading, which covers the relative parent with a white background
   * loading-dark - Same as 'loading', but with a dark spinner and background
   * inline - Renders spinner without a mask, which allows the parent to style and position it
   * inline-dark - Same as 'inline', but with a dark spinner and background
   */
  appearance: PropTypes.oneOf(APPEARANCE_OPTIONS),
  /** Set to false to hide the spinner */
  show: PropTypes.bool,
  testID: PropTypes.string,
};

Spinner.defaultProps = {
  appearance: DEFAULT_APPEARANCE,
  show: true,
  testID: '',
};
